
<div>
  <Heading
    :class="jel_getClassObject(content, { [content.type]: true })"
    :contentType="content.type"
    v-html="jel_replaceTokens(content.titre)"
  ></Heading>
</div>
